<div *ngIf="isPageReady" class="flex flex-col gap-3 p-1">

  <div *ngIf="!rrd" class="text-red-600">RRD #{{ params.rrdId }} not found.</div>

  <div *ngIf="rrd">
    <div class="qb-detail-card qb-primary-tint p-3 mb-3">
      <table class="qb-info-table">
        <tr><td class="label">RRD</td>            <td class="value">#{{ rrd.id }}</td></tr>
        <tr><td class="label">Job Order</td>      <td class="value">{{ rrd.returnRequest?.joHeader?.id }}</td></tr>
        <tr><td class="label">Account</td>        <td class="value">{{ rrd.returnRequest?.joHeader?.account?.accountName }}</td></tr>
        <tr><td class="label">Product</td>        <td class="value">{{ rrd.joDetail?.productTypeConfigName }}</td></tr>
        <tr><td class="label">Declared Qty</td>   <td class="value">{{ rrd.qty }}</td></tr>
        <tr><td class="label">Reason</td>         <td class="value">{{ rrd.returnReasonType?.name }}</td></tr>
        <tr><td class="label">Customer Notes</td> <td class="value">{{ rrd.returnExplanation }}</td></tr>
      </table>
    </div>

    <div class="text-sm text-muted mb-2">
      Enter the qty physically received at the warehouse. May differ from the declared qty.
    </div>

    <div class="grid grid-cols-12 gap-3 items-center mb-2">
      <label class="col-span-4 font-semibold">Received qty</label>
      <input #qtyInput pInputText type="number" min="0"
             class="col-span-4"
             title="Received qty"
             [(ngModel)]="receivedQty"
             [disabled]="submitting" />
    </div>

    <div *ngIf="errorMessage" class="text-red-600 mb-2">{{ errorMessage }}</div>
  </div>

  <div class="flex justify-end gap-2 pt-3 border-t">
    <button pButton type="button"
            class="p-button-text"
            [disabled]="submitting"
            (click)="cancel()">
      <span>Cancel</span>
    </button>
    <button pButton type="button"
            class="p-button-raised"
            icon="pi pi-check"
            [disabled]="!canSubmit"
            (click)="confirm()">
      <span>Confirm Receipt</span>
    </button>
  </div>
</div>
